import React from 'react';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { PrivateRoute } from './authorization';
import './App.scss';
import Home from './Routes/home';
import constants from './constants';
import Loader from './common-components/loader';
import { store } from './Components/redux/store';

function App() {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return <Loader fullscreen={true} />;
  }

  return (
    <Router>
      <Provider store={store}>
        <PrivateRoute
          path=""
          roles={[constants.keycloak.role]}
          component={Home}
        />
      </Provider>
    </Router>
  );
}

export default App;
